module.exports = __webpack_public_path__ + "img/dynamic-news.1fc50cc1.png";